"use strict";

require("core-js/modules/es.array.from");

var curry = require("./curry.js");

var takeAll = require("./takeAll.js");

var removeL = require("../Lazy/removeL.js");

module.exports = curry(function remove(start, count, iter) {
  if (iter === undefined) return remove(start, 1, count);

  if (start < 0) {
    iter = Array.from(iter);
    start += iter.length;
  }

  return takeAll(removeL(start, count, iter));
});